<template>
    <div>
        <v-dialog v-model="dialogStatusModel" kind="modal" status="default" class="application-dialog" @close="cancel">
            <div slot="title" class="application-title-text">
                {{ $t('信息修改申请表') }}
            </div>
            <div slot="caption" class="application-caption">
                <span v-tip:captionTip.hover class="application-caption-text" remote>
                    {{ $t('通过提交申请表，修改企业管理员信息') }}
                </span>
                <v-tip ref="captionTip" placement="top" clazz="application-caption-tip">
                    {{ $t('通过提交申请表，修改企业管理员信息') }}
                </v-tip>
            </div>
            <div>
                <div class="application-title">
                    <div class="application-title-name application-title-name--company">
                        <span class="application-title-label">{{ $t('企业全称：') }}</span>
                        <span v-tip:companyTip.hover class="application-title-value" remote>{{ info.company }}</span>
                        <v-tip ref="companyTip" placement="top" clazz="application-title-tip">
                            {{ info.company }}
                        </v-tip>
                    </div>
                    <div class="application-title-name application-title-name--uin">
                        <span class="application-title-label">{{ $t('企业主号：') }}</span>
                        <span v-tip:corpUinTip.hover class="application-title-value" remote>{{ info.corp_uin }}</span>
                        <v-tip ref="corpUinTip" placement="top" clazz="application-title-tip">
                            {{ info.corp_uin }}
                        </v-tip>
                    </div>
                </div>
                <div>
                    <v-steps :titles="stepTitles" :index="currentStep" />
                </div>
                <editContact v-show="currentStep === 1" :contact="info" :new-q-q="newQQ" />
                <uploadData v-show="currentStep === 2" ref="uploadData" :new-q-q="newQQ" :new-phone="newPhone"
                    :contact="info" />
            </div>
        </v-dialog>
        <qqLogin v-if="currentStep === 1 && showQQLogin" ref="qqLogin" :main="info" />
    </div>
</template>

<script>
import uploadData from './uploadData.vue';
import editContact from './editContact.vue';
import qqLogin from './qqLogin.vue';
export default {
    components: {
        uploadData,
        editContact,
        qqLogin,
    },
    props: {
        dialogStatus: {
            type: Boolean,
            default: false,
        },
        info: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            dialogStatusModel: false,
            stepTitles: [this.$t('修改联系方式'), this.$t('上传资料')],
            currentStep: 1,
            newQQ: '',
            newPhone: '',
            showQQLogin: false,
            selected: this.info.defaultSelect,
        };
    },
    watch: {
        dialogStatus: {
            handler(newVal) {
                this.dialogStatusModel = newVal;
            },
            deep: true,
        },
    },
    methods: {
        /**
         * 刷新QQ登录框的展现状态，因为登录框内部的iframe在登录成功之后会进行页面跳转，导致下一次打开弹框的时候展示空白，所以需要重置组件
         * @param {boolean} showQQLogin 展现状态
         * @return {void}
         */
        getShowQQLogin() {
            this.showQQLogin = false;
            this.$nextTick(() => {
                this.showQQLogin = true;
            });
        },
        /**
         * 记录一下新的QQ号
         * @param {number} newQQ QQ号
         * @return {void}
         */
        getNewQQFrom(newQQ) {
            this.newQQ = newQQ;
        },
        /**
         * 记录一下新的手机号
         * @param {number} newPhone QQ号
         * @return {void}
         */
         getNewPhoneFrom(newPhone) {
            this.newPhone = newPhone;
        },
        /**
         * 跳转到QQ登录界面
         * @param {Boolean} qq登录的开关
         * @return {void}
         */
        clickAddNewAdminQQ(status) {
            this.$refs.qqLogin.qqLoginFrameSwitch(status);
            // this.isOpenQQLoginFrame = status;
        },
        /**
         * 上一步
         * @return {void}
         */
         clickPreviousStep() {
            this.currentStep = 1;
        },

        /**
         * 下一步
         * @return {void}
         */
        clickNextStep() {
            this.currentStep = 2;
        },
        /**
         * 更新选中
         * @param {number} type - 选中项
         * @param {boolean} bool - 选中|取消
         */
        updateSelectedItems(type, bool) {
            if (bool) {
                if (!this.selected.includes(type)) this.selected.push(type);
            } else {
                this.selected.splice(this.selected.findIndex(item => item === type), 1);
            }
        },
        cancel(force = false) {
            const { uploadData } = this.$refs;
            if (!force && uploadData && uploadData.submitLoading) {
                this.dialogStatusModel = true;
                return;
            }
            if (uploadData) {
                uploadData.invalidateOcrRequests();
            }
            this.$emit('cancel');
        },
    },
};
</script>

<style lang="less" scoped>
.application-dialog {
    /deep/ .v-page-header {
        margin-bottom: 2px;
    }
    /* 真实 DOM 结构：
       .v-page-header__heading (flex 横向)
         ├── .v-page-header__heading__left (flex 横向：title + caption)
         └── .v-page-header__heading__extra (close 按钮)

       策略：
       - __heading 不动，保持其默认横向分布（left + extra）
       - 限宽作用在 __heading__left 上：总 472 - close 按钮(40) - 间距(≈12) ≈ 420px
       - 让 __left 内部允许收缩（min-width: 0），caption 才能 ellipsis
    */
    /deep/ .v-page-header__heading__left {
        max-width: 420px;
        min-width: 0;
        overflow: hidden;
    }
    /deep/ .v-page-header__heading__left__caption {
        min-width: 0;
        flex: 1 1 auto;
        overflow: hidden;
    }
    /deep/ .v-page-header__heading__left__title {
        flex: 0 0 auto;
        max-width: none;
    }
}

/* title 完整一行展示，永不省略、永不收缩 */
.application-title-text {
    flex: 0 0 auto;
    white-space: nowrap;
    overflow: visible;
    max-width: none;
}

/* caption 占剩余空间，超出单行省略 + hover tip */
.application-caption {
    display: flex;
    align-items: center;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
}

.application-caption-text {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    cursor: default;
}

.application-title {
    display: flex;
    text-align: left;
    width: 472px;
    max-width: 100%;
    justify-content: space-between;
    flex: 1;

    &-name {
        display: flex;
        align-items: center;
        margin-right: 24px;
        margin-bottom: 16px;
        min-width: 0;
        overflow: hidden;
        white-space: nowrap;
    }

    &-name--company {
        flex: 3 1 0;
    }

    &-name--uin {
        flex: 4 1 0;
        margin-right: 0;
    }

    &-label {
        flex: 0 0 auto;
        white-space: nowrap;
    }

    &-value {
        flex: 1 1 auto;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: default;
    }
}
</style>
<style lang="less">
.application-caption-tip {
    max-width: 360px;
    word-break: break-word;
    line-height: 20px;
}
.application-title-tip {
    max-width: 360px;
    word-break: break-word;
    line-height: 20px;
}
</style>
